// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4760bd3a","389":"5cf9c383","732":"df16d7da","857":"5a35dbf5","977":"f04ab914"}[chunkId] + ".chunk.js";
};